<template>
  <transition name="fade">
    <div class="send-tokens-modal" v-if="show">
      <FullBackdrop class="fenif-test">
        <div class="container">
          <div class="logo-container">
            <router-link :to="{ name: 'home' }">
              <div class="logo"></div>
            </router-link>
          </div>
  
          <p>{{ $t("welcome.title") }} <strong>DIVASPLAY!</strong></p>
  
          <div class="container-body">
            <p>{{ $t("welcome.message1") }}</p>
            <p>{{ $t("welcome.message2") }}</p>
          </div>
  
          <p>{{ $t("welcome.message3") }}</p>
          <p>{{ $t("welcome.footer") }} <strong>DIVASPLAY!</strong></p>
  
          <div class="footer">
            <button class="cancel active" @click="cancelHandler">
              {{ $t("go_back") }}
            </button>
          </div>
        </div>
      </FullBackdrop>
    </div>
  </transition>
</template>
<script>
import FullBackdrop from "./../FullBackdrop";

export default {
  components: { FullBackdrop },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    cancelHandler() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/classes";

.send-tokens-modal {

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;
    text-align: center;
    max-width: 600px;
    font-size: 1.25em;

    p {
      margin-top: 0;
    }

    .container-body {
      p {
        margin: 0;
      }
    }

    @media (min-width: 768px) {
      min-width: 350px;
      font-size: 1.5em;
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        @extend %fresh-btn;

        border-radius: 0.5rem;
      }
    }
  }
}

.logo-container {
  padding: 1em;

  .logo {
    display: block;
    margin: auto;
    height: 50px;
    min-width: 400px;
    width: 100%;
    background-image: var(--img-logo);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;

    @media (max-width: 500px) {
      min-width: auto;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
